import React from "react";
import { HvGrid } from "@hitachivantara/uikit-react-core";
import Container from "components/layout/Container";
import IncidentKpis from "components/map/IncidentsKpis";

const Map: React.FC = () => {
  return (
    <Container
      fullScreen={false}
      loadingProps={{
        loadingLabel: "",
      }}
    >
      <HvGrid container>
        <HvGrid item xs={12}>
          <IncidentKpis />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};

export default Map;
